import { type AuthUser, useAuth } from './use-auth'
import { useEffect, useState } from 'react'
import { type AnnualPlanRole } from '../models/AnnualPlanRole'
import { GetAnnualPlanTeam } from '../services/AnnualPlanService'

interface UseAnnualPlanUserRoleType {
  user: AuthUser | null
  userRole: AnnualPlanRole | null
  isLoading: boolean
  error: string | null
}

export const useAnnualPlanUserRole = (annualPlanId: number): UseAnnualPlanUserRoleType => {
  const { user } = useAuth()
  const [userRole, setUserRole] = useState<AnnualPlanRole | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchUserRole = async (): Promise<void> => {
    if (annualPlanId == null || annualPlanId === 0 || user == null) return

    try {
      setIsLoading(true)
      const planMembers = await GetAnnualPlanTeam(Number(annualPlanId))
      const member = planMembers.find(member => member.userId === user.id)

      if (member == null) {
        setError('User is not a member of this plan')
        return
      }

      setUserRole(member.annualPlanRole as AnnualPlanRole)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'An unknown error occured while fetching user role.')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    void fetchUserRole()
  }, [annualPlanId, user?.id])

  return { user, userRole, isLoading, error }
}
